import { render, staticRenderFns } from "./SurveyGroupForm.vue?vue&type=template&id=65976b2f"
import script from "./SurveyGroupForm.vue?vue&type=script&lang=js"
export * from "./SurveyGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports